import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { IGridService } from '../models/igrid-service';
import { TransporteurDto } from '@lexi-clients/lexi';
import { TransporteurListResult } from '../models/transporteur-list';

@Injectable({
  providedIn: 'root'
})
export class TransporteurListService implements IGridService<TransporteurDto> {
  baseUrl: string;

  constructor(private http: HttpClient, envService: EnvironmentService) {
    this.baseUrl = envService.environment.baseServiceUrl;
  }

  get(params: HttpParams): Observable<TransporteurListResult> {
    return this.http.get<any>(`${this.baseUrl}/api/Transporteurs/recherche-devexpress`, { params: params });
  }

  getById(transporteurId: number): Observable<TransporteurDto> {
    return this.http.get<any>(`${this.baseUrl}/api/Transporteurs/${transporteurId}`);
  }

  post(valeur: TransporteurDto): Observable<any> {
    return null;
  }

  put(valeur: TransporteurDto): Observable<any> {
    return null;
  }

  delete(valeur: TransporteurDto): Observable<any> {
    return null;
  }
}
